require('expose-loader?LandingPage!../src/app/landing_page');
